import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import noUiSlider from "noUiSlider";
import DataHelper from "@Scripts/Common/DataHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "RangeFilter" })
export default class RangeFilter extends Vue {
    public localizer: any = Localizer;
    public isListVisible: boolean = false;
    public sliderMinValue: number = null;
    public sliderMaxValue: number = null;
    public selectedMinValue: number = null;
    public selectedMaxValue: number = null;
    public currentMinValue: number = null;
    public currentMaxValue: number = null;

    get isContentLoading(): any {
        return this.$store.getters["catalogueStore/isContentLoading"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Watch("filters") onFiltersChanged(value: string, oldValue: string) {
        let filter = this.filters.find(x => x.name === this.filterSelector.name);

        if (!value || value.length === 0 || !filter?.value) {
            this.resetSliders();
        }
    }

    @Prop() readonly filters: any[];
    @Prop() readonly selectedFilter: string;
    @Prop() readonly filterSelector: any;
    @Prop() readonly page: string;

    public async created() {
        let extremes: any = this.filterSelector.listItems.map(x => x.value);
        this.sliderMinValue = Math.min(...extremes);
        this.sliderMaxValue = Math.max(...extremes);
        this.selectedMinValue = this.sliderMinValue;
        this.selectedMaxValue = this.sliderMaxValue;
        this.currentMinValue = this.sliderMinValue;
        this.currentMaxValue = this.sliderMaxValue;

        let filter = this.filters.find(x => x.name === this.filterSelector.name);
        if (filter?.value) {
            let values = filter.value.split(",");
            if (values.length === 2) {
                this.selectedMinValue = DataHelper.convertToNative(values[0], this.filterSelector.dataType);
                this.selectedMaxValue = DataHelper.convertToNative(values[1], this.filterSelector.dataType);
            }
        }
    }

    public async mounted() {
        this.setSlider();
        this.isListVisible = this.selectedFilter === this.filterSelector.name;
    }

    public setSlider() {
        let sliderElement: any = this.$refs.slider;

        noUiSlider.create(sliderElement, {
            start: [this.selectedMinValue, this.selectedMaxValue],
            step: 1,
            connect: true,
            range: { "min": this.sliderMinValue, "max": this.sliderMaxValue }
        });

        sliderElement.noUiSlider.on("set", (values, handle) => {
            let oldSelectedMinValue = this.selectedMinValue;
            let oldSelectedMaxValue = this.selectedMaxValue;

            handle === 1 ? this.selectedMaxValue = parseInt(values[handle]) : this.selectedMinValue = parseInt(values[handle]);

            if (oldSelectedMaxValue != this.selectedMaxValue || oldSelectedMinValue != this.selectedMinValue) {
                if (this.selectedMinValue === this.sliderMinValue && this.selectedMaxValue === this.sliderMaxValue) {
                    this.clearFilter();
                } else {
                    this.$emit("setFilter", this.filterSelector.name, DataHelper.convertToString(this.selectedMinValue, this.filterSelector.dataType) + "," + DataHelper.convertToString(this.selectedMaxValue, this.filterSelector.dataType));
                }
            }
        });

        sliderElement.noUiSlider.on("update", (values, handle) => {
            handle === 1 ? this.currentMaxValue = parseInt(values[handle]) : this.currentMinValue = parseInt(values[handle]);
        });
    }

    public async removeFilter() {
        this.clearFilter();
        this.resetSliders();
    }

    public async clearFilter() {
        this.$emit("setFilter", this.filterSelector.name, null);
    }

    public async resetSliders() {
        let sliderElement: any = this.$refs.slider;
        sliderElement.noUiSlider.set([this.sliderMinValue, this.sliderMaxValue]);
    }

    public formatNumber(value: number) {
        return new Intl.NumberFormat("it-IT").format(value);
    }

    public setIsListVisible() {
        this.isListVisible = !this.isListVisible;
    }
};